// Action Types
export const SELECT_POST = 'SELECT_POST';

// Actions
export const selectPost = data => ({ type: SELECT_POST, payload: data });



// WEBPACK FOOTER //
// ./src/app/states/post/post.actions.js